import React from 'react'

/**
 * Prevents unexpected render/runtime errors from blanking the whole app.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, info) {
        console.error('Uncaught UI error', error, info)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        maxWidth: 480,
                        margin: '80px auto',
                        padding: '0 16px',
                        textAlign: 'center',
                        fontFamily: 'inherit',
                    }}
                >
                    <h1
                        style={{
                            fontFamily: 'var(--font-heading)',
                            fontSize: 22,
                            marginBottom: 12,
                            letterSpacing: 'normal',
                            textTransform: 'none',
                        }}
                    >
                        Something went wrong
                    </h1>
                    <p style={{ color: '#555', marginBottom: 24 }}>
                        Please refresh the page and try again.
                    </p>
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 20px',
                            border: '1px solid #333',
                            background: '#fff',
                            cursor: 'pointer',
                        }}
                    >
                        Refresh
                    </button>
                </div>
            )
        }

        return this.props.children
    }
}
